import { BatchEditPostBackground, claims, contracts } from 'api/endpoints';

import { api } from 'api';
import { isPlainObject } from 'lodash';
import { SectionType } from 'pages/ClaimsContractsToolPage/types';
import { IBatchItem } from '../claimsBatchEdit.type';

export const postBatchEdit = async (ids: string[], items: IBatchItem[]) => {
  const nonEmptyItems = items.filter((r) => r.propName);
  const values = nonEmptyItems.reduce(
    (accumulator, v) => ({ ...accumulator, ...toBatchField(v) }),
    {},
  );

  const claimIds = ids.map((r) => +r);
  return api.claims.batchEdit({ claimIds, values });
};

const toBatchField = (v: IBatchItem) =>
  isPlainObject(v.value) ? (v.value as object) : { [v.propName]: v.value };

export const apiBatchEditUploadBackground = async (
  data: BatchEditPostBackground,
  section: SectionType,
) => {
  switch (section) {
    case SectionType.Claims:
      return claims.batchEditUploadBackground(data);
    case SectionType.Contracts:
      return contracts.batchEditUploadBackground(data);
  }
};
